var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_5444)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23397 0H0V2.5L18.7539 15L21 15V12.5L2.23397 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.745098 0L21 13.5354V15H20.2724L0 1.45056V0H0.745098Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0H21V2.5C21 2.5 8.0098 10.8281 2 15H0V12.5L19 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 0H20.3218L0 13.5471V15H0.745098L21 1.46151V0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63708 0H13.3804V4.62682H21V10.3701H13.3804V15H7.63708V10.3701H0V4.62682H7.63708V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8421 0H12.1579V5.76923H21V9.23077H12.1579V15H8.8421V9.23077H0V5.76923H8.8421V0Z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_5444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnGb);
export default __webpack_public_path__ + "static/media/en-GB.31c3625d7381cab599cae45b53cf2d91.svg";
export { ForwardRef as ReactComponent };